/**
 * 应用侧唯一的 api-client 实例。
 *
 * ⚠ 令牌失效的通知是个「后绑」的回调：api-client 不认识 Zustand，
 *   由 auth store 在启动时把自己挂进来(见 `onAuthLost`)。
 */
import { createApiClient, type AuthLostReason } from '@cione/api-client'
import { createPersistentTokenStore } from './token-storage'

const BASE_URL =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? 'http://localhost:8080'

let authLostHandler: ((reason: AuthLostReason) => void) | null = null

/** 由 auth store 注册。⚠ 整个刷新周期只会触发一次，所以登录框也只弹一次。 */
export function setAuthLostHandler(handler: (reason: AuthLostReason) => void): void {
  authLostHandler = handler
}

export const tokenStore = createPersistentTokenStore()

export const api = createApiClient({
  baseUrl: BASE_URL,
  tokenStore,
  onAuthLost: (reason) => authLostHandler?.(reason),
})
